import {Injectable} from '@angular/core';
import {environment} from './../../../environments/environment';
import {HttpRequestService} from './../../shared/services/http-request.service';
import {HttpClient} from '@angular/common/http';

import {
  PictureChoiceUploadModel,
  SaveReportModel,
  SurveyCreatePDModel,
  SurveyPermissionModel,
  SurveyQuestionModel,
  SurveyUpdateModel,
  SurveyQuestionChartModel,
  SurveyMailListModel,
  ExclusionCriteriaModel,
  SmartAnalysisModel,
  DifferenceType,
  BundleQuestionModel,
} from '../../models/survey/survey.model';
import {SummaryFilterModel} from '../../models/summary/summary.model';
import {HideQuestionCreateModel} from '../../models/hide-question/hide-question.model';
import { ImportFromSystemType } from '../../shared/constants/input.constants';
import { SurveyUserSettingModel } from '../../models/survey-user-setting/survey-user-setting.model';
@Injectable()
export class SurveyService {

  private defineNewSurveyUrl = environment.apiUrl + '/Survey/DefineNewSurvey';
  private getSurveyPDModelUrl = environment.apiUrl + '/Survey/GetSurveyPDModel';
  private preSaveUrl = environment.apiUrl + '/Survey/PreSave';
  private saveUrl = environment.apiUrl + '/Survey/Save';
  private updateTitleUrl = environment.apiUrl + '/Survey/UpdateWorkspaceName';
  private getSurveyUrl = environment.apiUrl + '/Survey/GetSurveyForUpdate';
  private pictureUploadUrl = environment.apiUrl + '/Survey/UploadPictureChoicePhoto';
  private publishSurveyUrl = environment.apiUrl + '/Survey/PublishSurvey';
  private unpublishSurveyUrl = environment.apiUrl + '/Survey/UnpublishSurvey';
  private getMasterSummaryPDModelUrl = environment.apiUrl + '/Survey/GetMasterSummaryPDModel';
  private getMasterSummaryForPeopleUrl = environment.apiUrl + '/Survey/GetMasterSummaryForPeople';
  private getReportSummaryPDModelUrl = environment.apiUrl + '/Survey/GetReportSummary';
  private getListOfReportsUrl = environment.apiUrl + '/Survey/GetListOfReports';
  private getGetReportCreateModelUrl = environment.apiUrl + '/Survey/GetReportCreateModel';
  private saveReportUrl = environment.apiUrl + '/Survey/SaveReport';
  private getReportUrl = environment.apiUrl + '/Survey/GetCustomReport';
  private getReportForPeopleUrl = environment.apiUrl + '/Survey/GetMasterSummaryForPeopleForCustomReport';
  private getPaymentUrl = environment.apiUrl + '/Survey/GetPaymentPDModel';
  private payPeopleUrl = environment.apiUrl + '/Survey/PayPeople';
  private deleteSurveyFullUrl = environment.apiUrl + '/Survey/DeleteSurveyFull';
  private importSpreadsheetUrl = environment.apiUrl + '/Survey/ImportSpreadsheet';
  private getListSurveyQuestionFilterUrl = environment.apiUrl + '/Survey/GetListSurveyQuestionFilter';
  private getListIncludeSurveyUrl = environment.apiUrl + '/Survey/GetIncludeVersion?surveyId=';
  private getMasterSummaryPDModelByQuestionFilterUrl = environment.apiUrl + '/Survey/GetMasterSummaryPDModelByQuestionFilter';
  private getTranslateAnswerQuestionsUrl = environment.apiUrl + '/Survey/GetTranslateAnswerQuestions';
  private getMasterSummaryForPeopleByQuestionFilterUrl = environment.apiUrl + '/Survey/GetMasterSummaryForPeopleByQuestionFilter';
  private saveCutUrl = environment.apiUrl + '/Cut/Save';
  private updateCutUrl = environment.apiUrl + '/Cut/Update';
  private getCutsUrl = environment.apiUrl + '/Cut/GetCutBySurvey';
  private deleteCutUrl = environment.apiUrl + '/Cut/DeleteCut';
  private updateCutTitleUrl = environment.apiUrl + '/Cut/UpdateTitle';
  private getCutUrl = environment.apiUrl + '/Cut/GetCut';
  private getTitleSurveyUrl = environment.apiUrl + '/Survey/GetSurveyTitle';
  private saveHideQuestionUrl = environment.apiUrl + '/HideQuestion/Save';
  private getHideQuestionUrl = environment.apiUrl + '/HideQuestion/GetHideQuestion';
  private unhideQuestionUrl = environment.apiUrl + '/HideQuestion/UnhideQuestion';
  private getSurveyPermissionUrl = environment.apiUrl + '/Survey/GetSurveyPermission';
  private getSurveyMailListUrl = environment.apiUrl + '/Survey/GetSurveyMailList';
  private updateSurveyPermissionUrl = environment.apiUrl + '/Survey/UpdateSurveyPermission';
  private updateSurveyMailListUrl = environment.apiUrl + '/Survey/UpdateSurveyMailList';
  private getAllSurveySimpleModelUrl = environment.apiUrl + '/Survey/GetAllSurveySimpleModel';
  private syncResponseUrl = environment.apiUrl + '/Survey/SyncResponse';
  private reSyncResponseUrl = environment.apiUrl + '/Survey/ReSyncResponse';
  private getAllClientUrl = `${environment.apiUrl}/Client/GetAllClient`;
  private getAllActiveClientUrl = `${environment.apiUrl}/Client/GetAllActiveClient`;
  private getAllLanguageUrl = `${environment.apiUrl}/Language/GetAllLanguage`;
  private getSurveyImportBySystemUrl = environment.apiUrl + '/Survey/GetSurveyImportBySystem';
  private getSurveyAnswersWordCloudURL = environment.apiUrl + '/Survey/GetSurveyAnswersWordCloud';
  private getResponseTextByQuestionURL = environment.apiUrl + '/Survey/GetWordCloudFromQuestion';
  private saveExclusionCriteriaURL = environment.apiUrl + '/ExclusionCriteria/Save';
  private updateExclusionCriteriaURL = environment.apiUrl + '/ExclusionCriteria/Update';
  private getExclusionCriteriaBySurveyURL = environment.apiUrl + '/ExclusionCriteria/GetBySurvey';
  private getSurveysByWorkSpaceNameURL = environment.apiUrl + '/Survey/GetListSurveyByWorkSpace';
  private getSurveyVersionLanguageURL = environment.apiUrl + '/Survey/GetSurveyVersionLanguage';
  private getSurveyLanguageURL = environment.apiUrl + '/Survey/GetSurveyLanguage';
  private updateSurveyUserSettingURL = environment.apiUrl + '/Survey/UpdateSurveyUserSetting';
  private getSurveyUserSettingURL = environment.apiUrl + '/Survey/GetSurveyUserSetting';
  private deleteSurveyUserSettingURL = environment.apiUrl + '/Survey/DeleteSurveyUserSetting';
  private mailListRunNowURL = environment.apiUrl + '/Survey/MailListRunNow';
  private getSurveyQuestionForBundleQuestionURL = environment.apiUrl + '/Survey/GetSurveyQuestionForBundleQuestion'
  private updateBundleQuestionURL = environment.apiUrl + '/Survey/UpdateBundleQuestion';
  private getAllBundlesURL = environment.apiUrl + '/Survey/GetAllBundles';
  private getBundleURL = environment.apiUrl + '/Survey/GetBundle';
  private deleteBundleURL = environment.apiUrl + '/Survey/DeleteBundle';
  private getBundleByNameURL = environment.apiUrl + '/Survey/GetBundleByName';
  private updateSurveyUserSettingForCutURL = environment.apiUrl + '/Survey/UpdateSurveyUserSettingForCut';

  private SMART_ANALYS_RESULTS_KEY = 'outliers_key';

  surveyCreatePDModel: SurveyCreatePDModel;
  questionsHierarchy: SurveyQuestionModel[];

  constructor(private http: HttpRequestService, private httpClient: HttpClient) {
  }

  sortListSurveyQuestionModel() {
    const temp = [];
    this.questionsHierarchy.forEach(q => {
      temp.push(q);
      if (q.childQuestions.length) {
        q.childQuestions.forEach(cq => {
          temp.push(cq);
        });
      }
    });
    this.surveyCreatePDModel.listSurveyQuestionModel = temp;
  }

  getSurveyPDModel(clientId) {
    return this.http.get(this.getSurveyPDModelUrl + '?clientId=' + clientId, false);
  }

  getMasterSummaryPeople(id, page) {
    return this.http.get(this.getMasterSummaryForPeopleUrl + '?surveyId=' + id + '&pageSize=10' + '&page=' + page);
  }

  getAllMasterSummaryForPeopleByQuestionFilter(id: number, summaryFilterModel: SummaryFilterModel) {
    return this.http.post(this.getMasterSummaryForPeopleByQuestionFilterUrl + '?surveyId=' + id,
      summaryFilterModel,
      false);
  }

  getPayment(id, filter) {
    return this.http.get(this.getPaymentUrl + '?surveyId=' + id + '&filter=' + filter);
  }

  defineNewSurvey(data: SurveyCreatePDModel) {
    return this.http.post(this.defineNewSurveyUrl, data, false);
  }

  preSave(data: SurveyCreatePDModel) {
    return this.http.post(this.preSaveUrl, data, false);
  }

  save(data: SurveyCreatePDModel) {
    return this.http.post(this.saveUrl, data, false);
  }

  updateWorkspaceName(data: SurveyUpdateModel) {
    return this.http.put(this.updateTitleUrl, data, false);
  }

  getSurvey(id: number) {
    return this.http.get(this.getSurveyUrl + '?id=' + id, false);
  }

  pictureUpload(files, data: PictureChoiceUploadModel) {
    return this.http.postMultipart(this.pictureUploadUrl, data, files);
  }

  publishSurvey(id: number) {
    return this.http.put(this.publishSurveyUrl + '?surveyId=' + id, false);
  }

  unpublishSurvey(id: number) {
    return this.http.put(this.unpublishSurveyUrl + '?surveyId=' + id, false);
  }

  getMasterSummaryPDModel(id: number, filterOption: string) {
    return this.http.get(this.getMasterSummaryPDModelUrl + '?surveyId=' + id + '&filterOption=' + filterOption);
  }

  getMasterSummaryPDModelByQuestionFilter(id: number, summaryFilterModel: SummaryFilterModel) {
    return this.http.post(this.getMasterSummaryPDModelByQuestionFilterUrl + '?surveyId=' + id, summaryFilterModel, false);
  }

  getTranslateAnswerQuestions(summaryFilterModel: SummaryFilterModel) {
    return this.http.post(this.getTranslateAnswerQuestionsUrl, summaryFilterModel, false);
  }

  getReportSummaryPDModel(id: number) {
    return this.http.get(this.getReportSummaryPDModelUrl + '?surveyId=' + id);
  }

  saveCut(data: any) {
    return this.http.post(this.saveCutUrl, data, true, 'Successfully saved segment');
  }

  updateCut(id, data: any) {
    return this.http.put(this.updateCutUrl + '?id=' + id, data, true, 'Successfully saved segment');
  }

  deleteCut(id) {
    return this.http.delete(this.deleteCutUrl + '?id=' + id, true, 'Successfully deleted segment');
  }

  updateCutTitle(id, title) {
    return this.http.post(this.updateCutTitleUrl + '?id=' + id, {title});
  }

  getCuts(id) {
    return this.http.get(this.getCutsUrl + '?surveyId=' + id);
  }

  getCut(id) {
    return this.http.get(this.getCutUrl + '?cutId=' + id);
  }

  getReports(id) {
    return this.http.get(this.getListOfReportsUrl + '?surveyId=' + id);
  }

  getReport(reportId, page) {
    return this.http.get(this.getReportUrl + '?reportId=' + reportId + '&pageSize=10' + '&page=' + page);
  }

  getReportForPeople(reportId, page) {
    return this.http.get(this.getReportForPeopleUrl + '?reportId=' + reportId + '&pageSize=10' + '&page=' + page);
  }

  getReportCreateModel(id: number) {
    return this.http.get(this.getGetReportCreateModelUrl + '?surveyId=' + id, false);
  }

  saveReport(data: SaveReportModel) {
    return this.http.post(this.saveReportUrl, data, false);
  }

  payPeople(data) {
    return this.http.post(this.payPeopleUrl, data);
  }

  deleteSurveyFull(surveyId) {
    return this.http.delete(this.deleteSurveyFullUrl + '?surveyId=' + surveyId, true, 'Successfully deleted survey');
  }

  importSpreadsheet(file) {
    return this.http.postMultipart(this.importSpreadsheetUrl, null, file);
  }

  getListSurveyQuestionFilter(id) {
    return this.http.get(this.getListSurveyQuestionFilterUrl + '?surveyId=' + id);
  }

  getListIncludeVersion(id: number) {
    return this.http.get(this.getListIncludeSurveyUrl + id);
  }

  getTitleSurvey(id: number) {
    return this.http.get(this.getTitleSurveyUrl + '?surveyId=' + id, false);
  }

  getHideQuestion(surveyId: number) {
    return this.http.get(this.getHideQuestionUrl + '?surveyId=' + surveyId, false);
  }

  saveHideQuestion(hideQuestion: HideQuestionCreateModel) {
    return this.http.post(this.saveHideQuestionUrl, hideQuestion, false);
  }

  unhideQuestion(ids: number[]) {
    return this.http.post(this.unhideQuestionUrl, ids, false);
  }

  getSurveyPermission(surveyId: number) {
    return this.http.get(this.getSurveyPermissionUrl + '?surveyId=' + surveyId, false);
  }


  getSurveyMailList(surveyId: number) {
    return this.http.get(this.getSurveyMailListUrl + '?surveyId=' + surveyId, false);
  }

  updateSurveyPermission(surveyPermission: SurveyPermissionModel) {
    return this.http.post(this.updateSurveyPermissionUrl, surveyPermission, false);
  }


  updateSurveyMailList(surveyMailListModel: SurveyMailListModel) {
    return this.http.put(this.updateSurveyMailListUrl, surveyMailListModel, false);
  }

  getAllSurveySimpleModel() {
    return this.http.get(this.getAllSurveySimpleModelUrl, false);
  }

  syncResponse(surveyId: number) {
    return this.http.get(this.syncResponseUrl + '?surveyId=' + surveyId, false);
  }

  reSyncResponse(surveyId: number) {
    return this.http.get(this.reSyncResponseUrl + '?surveyId=' + surveyId, false);
  }

  getAllClient() {
    return this.http.get(this.getAllClientUrl, false);
  }

  getAllActiveClient() {
    return this.http.get(this.getAllActiveClientUrl, false);
  }

  getAllLanguage() {
    return this.http.get(this.getAllLanguageUrl, false);
  }

  getSurveyImportBySystem(importFromSystem: string, clientId: number) {
    return this.http.get(this.getSurveyImportBySystemUrl + '?importFromSystem=' + importFromSystem + `&clientId=${clientId}`);
  }

  getSurveyAnswersWordCloud( questionId: number) {
    return this.http.get(this.getSurveyAnswersWordCloudURL + `?questionId=${questionId}` );
  }

  getResponseTextByQuestion(surveyId: number, questionId: number, summaryFilterModel: SummaryFilterModel, hash: string, cutId: number) {
    return this.http.post(this.getResponseTextByQuestionURL + `?questionId=${questionId}&surveyId=${surveyId}&hash=${hash}&cutId=${cutId}`, summaryFilterModel, false);
  }


  saveExclusionCriteria(exclusionCriteriaModel: ExclusionCriteriaModel) {
    return this.http.post(this.saveExclusionCriteriaURL, exclusionCriteriaModel, true );
  }

  getExclusionCriteriaBySurvey(idSurvey: number) {
    return this.http.get(this.getExclusionCriteriaBySurveyURL+ `?IdSurvey=${idSurvey}` );
  }

  updateExclusionCriteria(exclusionCriteriaModel: ExclusionCriteriaModel) {
    return this.http.put(this.updateExclusionCriteriaURL, exclusionCriteriaModel, false );
  }

  getExclusionCriteria(id: number) {
    return this.http.get(this.saveExclusionCriteriaURL + `?Id=${id}` );
  }


  getSurveysByWorkSpaceName(workSpaceName: string, provider: ImportFromSystemType, clientId: number) {
    return this.http.post(this.getSurveysByWorkSpaceNameURL, {'NameWorkSpace': workSpaceName, 'Provider': provider, 'ClientId': clientId }, false );
  }

  getSurveyVersionLanguage(idSurvey: number){
    return this.http.get(this.getSurveyVersionLanguageURL+ `?idSurvey=${idSurvey}`, false );
  }

  getSurveyLanguage(idSurvey: number){
    return this.http.get(this.getSurveyLanguageURL+ `?idSurvey=${idSurvey}`, false );
  }

  updateSurveyUserSetting(data: SurveyUserSettingModel) {
    return this.http.post(this.updateSurveyUserSettingURL, data, false);
  }

  getSurveyUserSetting(idSurvey: number) {
    return this.http.get(this.getSurveyUserSettingURL + `?idSurvey=${idSurvey}`, false );
  }

  deleteSurveyUserSetting(data: SurveyUserSettingModel) {
    return this.http.post(this.deleteSurveyUserSettingURL, data, false);
  }

  mailListRunNow(id: number) {
    return this.http.get(this.mailListRunNowURL + '?surveyId=' + id, false);
  }

  getSmartAnalysisResults(): SmartAnalysisModel {
    if (sessionStorage.getItem(this.SMART_ANALYS_RESULTS_KEY) !== null) {
      return JSON.parse(sessionStorage.getItem(this.SMART_ANALYS_RESULTS_KEY));
    }
    return null;
  }

  setSmartAnalysisResults(model: SmartAnalysisModel) {
    sessionStorage.setItem(this.SMART_ANALYS_RESULTS_KEY, JSON.stringify(model));
  }

  removeSmartAnalysisResults() {
    sessionStorage.removeItem(this.SMART_ANALYS_RESULTS_KEY);
  }
 
  removeSmartAnalysisWithoutAnalysisAllResults() {
    const model = this.getSmartAnalysisResults();
    if (model !== null && !model.isAnalysisAll) {
        this.removeSmartAnalysisResults();
    }
  }

  resetSmartAnalysisResults() {
    const model = this.getSmartAnalysisResults();
    if (model !== null && model.isAnalysisAll) {
        model.outliers = undefined;
        this.setSmartAnalysisResults(model);
    } else {
        this.removeSmartAnalysisResults();
    }
  }

  getSurveyQuestionForBundleQuestion(id: number, bundleId: number) {
    return this.http.get(this.getSurveyQuestionForBundleQuestionURL + '?surveyId=' + id + '&bundleId=' + bundleId, false);
  }

  updateBundleQuestion(data: BundleQuestionModel) {
    return this.http.post(this.updateBundleQuestionURL, data, false);
  }

  getAllBundles(id: number) {
    return this.http.get(this.getAllBundlesURL + '?surveyId=' + id, false);
  }

  getBundle(id: number) {
    return this.http.get(this.getBundleURL + '?bundleId=' + id, false);
  }

  deleteBundle(id: number) {
    return this.http.get(this.deleteBundleURL + '?bundleId=' + id, false);
  }

  getBundleByName(id: number, bundleName: string, bundleId?: number) {
    return this.http.get(this.getBundleByNameURL + '?surveyId=' + id + '&bundleName=' + bundleName + '&bundleId=' + bundleId, false);
  }

  updateSurveyUserSettingForCut(data: SurveyUserSettingModel) {
    return this.http.post(this.updateSurveyUserSettingForCutURL, data, false);
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/surveys.service.ts